/*
 * EGR lot certificates, keyed by variant SKU (the SKU column in Shopify).
 * Empty until real certificates are available: with no entry, a size shows no
 * lot number, no purity and no certificate anywhere on the store.
 *
 * Add one entry per released lot, for example:
 *
 * window.EGR_LOTS = {
 *   "EG-RDT-10MG": [
 *     {
 *       number: "2610-001",          // printed on the vial label
 *       testedAt: "2026-10-01",      // YYYY-MM-DD
 *       purity: 99.12,               // HPLC %, or null for reagents
 *       massTheoretical: 4731.4,     // Da, optional
 *       massObserved: 4731.2,        // Da, optional
 *       lab: "Lab name",             // optional
 *       coaUrl: "https://…/coa.pdf"  // link to the real certificate (upload it in Content > Files)
 *     }
 *   ]
 * };
 */
window.EGR_LOTS = {};
